import '@/assets/style/overlay.css';
import React from 'react';
import { Spin } from 'antd';
import Loader from '../components/Loader';

/**
 * LoadingOverlay component to display a loading spinner overlay.
 *
 * @param {Object} props - Component properties.
 * @param {boolean} props.loading - Determines if the loading overlay is visible.
 * @returns {JSX.Element} - Rendered LoadingOverlay component.
 */
const LoadingOverlay = ({ loading }) => {
  return (
    <>
      {loading && (
        <div className="overlay">
          <div className="spin-container">
            {/* <Loader /> */}
            <Spin />
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingOverlay;
